import flow from 'lodash/flow';

import { Component } from 'react';
import connectAsync from '../../utils/connectAsync';
import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import withLotameTargeting from '../../decorators/ads/withLotameTargeting';
import Error404 from '../errors/404';

import getRadioContext from '../../routes/utils/getRadioContext';
import fetchTopic from '../../utils/connectors/fetchTopic';
import fetchProfile from '../../utils/connectors/fetchProfile';
import fetchAudioClip from '../../utils/connectors/fetchAudioClip';

import { isProfile } from '../../utils/guideItemTypes';
import ProfileLoader from './ProfileLoader';

class ProfileRoute extends Component {
  render() {
    const { guideId } = getRadioContext(this.props) || {};

    if (isProfile(guideId)) {
      return <ProfileLoader {...this.props} />;
    }

    return <Error404 {...this.props} />;
  }
}

export default flow(
  withAdScreenRequest(() => 'profile'),
  withLotameTargeting,
  connectAsync([
    fetchProfile(getRadioContext),
    fetchTopic(getRadioContext),
    fetchAudioClip(getRadioContext),
  ]),
)(ProfileRoute);
